import "./src/styles/themes.css"

export const onRouteUpdate = () => {
  const wrapper = document.getElementById('gatsby-focus-wrapper');
  if (wrapper) {
    wrapper.removeAttribute('tabindex');
  }
};
